<style scoped>
   .section-block {
      margin-bottom: 1.5rem;
   }

   .section-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 1rem;
      padding-bottom: 0.75rem;
      border-bottom: 1px solid #e5e7eb;
   }

   .section-title {
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      color: #111;
   }

   .section-sub {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
   }
</style>
<template>
   <div class="">
      <app-overlay-loader v-if="preloader" />
      <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
         <div class="content-wrapper h-100">
            <div class="row">
               <ProductOrder  :selectedCardIndex="this.selectedCardIndex"
                              :selectedProducts="this.selectedProducts"
                              :country="this.pd_country"
                              @handleCardClick="handleCardClick"
                              @removeProduct="removeProduct"
                              @duplicateProduct="duplicateProduct"
                              :read="is_view"
               />

               <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
                  <div class="section-block">
                     <div class="section-header">
                        <div>
                           <h3 class="section-title">Product</h3>
                           <p class="section-sub">Select and configure the product</p>
                        </div>
                     </div>
                     <div class="row">
                        <SelectCustom v-model="inputs.pd_item" :is_view="is_view || isFromCost" :list="items" label="Item" :required="true"/>
                        <SelectCustom v-model="inputs.pd_typedata" :is_view="is_view || isFromCost" :list="orgConv" label="Org/Conv" />
                        <SelectHttp v-model="inputs.pd_product" @input="updateTariff" :is_view="is_view || isFromCost" label="Product" :required="true" url="/products/serverside/selectable-name" listValueField="name"/> 
                        <SelectCustom v-model="inputs.pd_subCategory" @input="updateTariff" :is_view="is_view || isFromCost" :list="sub_categories" label="Sub category" />
                        <SelectCustom v-model="inputs.pd_feature" :is_view="is_view || isFromCost" :list="featureList" label="Feature" />
                        <SelectCustom v-model="inputs.pd_cut_size" :is_view="is_view || isFromCost" :list="cutSizes" label="Cut-size" />
                        <SelectCustom v-model="inputs.pd_variety" :is_view="is_view" :list="varietyList" label="Variety" />
                        <SelectCustom v-model="inputs.pd_grade" :is_view="is_view || isFromCost" :list="gradeLists" label="Grade" />
                        <SelectCustom v-model="inputs.pd_crop" :is_view="is_view || isFromCost" :list="cropList" label="Crop" />
                        <InputNumber v-model="inputs.pd_quantity" :is_view="is_view || isFromCost" label="Quantity" :required="true"/>
                        <SelectCustom v-model="inputs.pd_pack" :is_view="is_view || isFromCost" :list="pack" label="Pack" :required="true" />
                        <InputNumber v-model="inputs.pd_weight" :is_view="is_view || isFromCost" label="Weight" :required="true"/>
                        <SelectHttp v-model="inputs.pd_net" :is_view="is_view || isFromCost" label="Net" url="/units/serverside/selectable-name" listValueField="code" :required="true" /> 
                        <TextArea v-model="inputs.pd_note" :is_view="is_view" label="Additional Info Commodity"/>
                     </div>
                  </div>

                  <div class="section-block">
                     <div class="section-header">
                        <div>
                           <h3 class="section-title">Supplier Price</h3>
                           <p class="section-sub">Select and configure the supplier price</p>
                        </div>
                     </div>
                     <div class="row">
                        <SelectHttp v-model="inputs.pd_supplierCurrency" :is_view="is_view || isFromCost" label="Supplier Currency" url="/currency/serverside/selectable-name" listValueField="Code"/> 
                        <InputNumber v-model="inputs.pd_suplierPrice" :is_view="is_view || isFromCost" label="Supplier Price"/>
                        <SelectHttp v-model="inputs.pd_supplierUnit" :is_view="is_view || isFromCost" label="Supplier Unit" url="/units/serverside/selectable-name" listValueField="code"/> 
                        <InputNumber v-model="inputs.supplier_additional_fees" :is_view="is_view" label="Supplier Additional Fees" divGridClass="col-sm-4"/>
                        <InputText v-model="supplierTotalPrice" :is_view="true" label="Supplier Total Price" />   
                        <TextArea v-model="inputs.supplier_additional_fees_comment" label="Supplier Additional Fees Comment" :is_view="is_view" divGridClass="col-sm-4" />
                        <TextArea v-model="inputs.supplier_price_detail" label="Supplier Price Detail" :is_view="is_view" divGridClass="col-sm-6" />
                        <TextArea v-model="inputs.supplier_qty_detail" label="Supplier Quantity Detail" :is_view="is_view" divGridClass="col-sm-6" />
                     </div>
                  </div>   

                  <div class="section-block">
                     <div class="section-header">
                        <div>
                           <h3 class="section-title">Customer Price</h3>
                           <p class="section-sub">Select and configure the customer price</p>
                        </div>
                     </div>
                     <div class="row">
                        <SelectHttp v-model="inputs.pd_customerCurrency" :is_view="is_view || isFromCost" label="Customer Currency" url="/currency/serverside/selectable-name" listValueField="Code"/> 
                        <InputNumber v-model="inputs.pd_customerPrice" :is_view="is_view || isFromCost" label="Customer Price"/>
                        <SelectHttp v-model="inputs.pd_customerUnit" :is_view="is_view || isFromCost" label="Customer Unit" url="/units/serverside/selectable-name" listValueField="code"/> 
                        <InputNumber v-model="inputs.customer_additional_fees" :is_view="is_view" label="Customer Additional Fees" divGridClass="col-sm-4"/>
                        <InputText v-model="customerTotalPrice" :is_view="true" label="Customer Total Price" />   
                        <TextArea v-model="inputs.customer_additional_fees_comment" label="Customer Additional Fees Comment" :is_view="is_view" divGridClass="col-sm-4" />
                        <TextArea v-model="inputs.customer_price_detail" label="Customer Price Detail" :is_view="is_view" divGridClass="col-sm-6"/>
                        <TextArea v-model="inputs.customer_qty_detail" label="Customer Quantity Detail" :is_view="is_view" divGridClass="col-sm-6"/>
                     </div>
                  </div> 

                  <div class="section-block">
                     <div class="section-header">
                        <div>
                           <h3 class="section-title">Logistics & Commodity</h3>
                           <p class="section-sub">Define destination, taxes, and quantity details</p>
                        </div>
                     </div>
                     <div class="row">
                        <SelectHttp v-model="inputs.pd_country_destination" @input="updateTariff" :is_view="is_view" label="Country of Destination" url="/countries/serverside/selectable-name" listValueField="name"/> 
                        <InputText v-model="inputs.pd_hts_code" :is_view="true" label="HTS Code" />   
                        <InputText v-model="inputs.pd_duty" :is_view="true" label="Duty" />   
                        <InputText v-model="inputs.pd_tariff" :is_view="true" label="Tariff" />   
                        <InputNumber v-model="inputs.pd_loads" :is_view="is_view" label="Loads" :required="true"/>
                        <InputNumber v-model="inputs.pd_quantity_detail" :is_view="is_view" label="Quantity Detail" />
                     </div>
                  </div> 

               </div>
            </div>
            <div class="row">
               <div class="col-md-3">
                  <button type="button" class="btn btn-primary mr-2 w-100" @click="redirectToSupplierDetail"> {{ $t("continue") }} </button>
               </div>
               <div class="col-md-3"></div>
               <div class="col-md-3"></div>
               <div class="col-md-3">
                  <button type="button" class="btn btn-success mr-2 w-100" @click="updateFilteredData" > {{ $t("save_product") }} </button>
               </div>
            </div>
         </div>
      </form>
   </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import SelectCustom from '../components/SelectCustom.vue';
import SelectHttp from '../components/SelectHttp.vue';
import InputNumber from '../components/InputNumber.vue';
import InputText from "../components/InputText.vue";
import TextArea from "../components/TextArea.vue";
import ProductOrder from "../components/ProductOrder.vue";
import {get_data_customTable, get_tariff, get_data_products} from '../mixins/api.js';
import {validateForm} from '../mixins/functions.js';

export default {
   name: "products-detail",
   mixins: [FormMixin],
   components: {
      SelectCustom, SelectHttp, InputNumber, InputText, TextArea, ProductOrder
   },
   data() {
      return {
         isFromCost : false,
         contractId: null,
         preloader: false,
         selectedProducts: [],
         items: [],
         sub_categories: [],
         cutSizes: [],
         featureList: [],
         varietyList : [],
         gradeLists: [],
         orgConv: [],
         cropList: [],
         pack: [],
         customerUnit: [],
         inputs: {
            pd_item: null,
            pd_typedata: null, // OrgConv
            pd_subCategory: null,
            pd_product: { id: null },
            pd_feature: null,
            pd_variety: null,
            pd_cut_size: null,
            pd_grade: null,
            pd_crop: null,
            pd_quantity: null,
            pd_pack: null,
            pd_weight: null,
            pd_net: { id: null, },
            pd_supplierCurrency: { id: null },
            pd_suplierPrice: null,
            pd_supplierUnit: {id: null},
            pd_customerCurrency: { id: null },
            pd_customerPrice: null,
            pd_customerUnit: {id: null},
            pd_country_destination: { id: null },
            pd_hts_code : null,
            pd_duty: null,
            pd_tariff: null,
            pd_loads: null,
            pd_quantity_detail : null,
            pd_note: null,
            pd_unique_id : null,
            pd_contrac_product_id: null,
            supplier_price_detail : null,
            supplier_qty_detail : null,
            customer_price_detail : null,
            customer_qty_detail : null,
            supplier_additional_fees : null,
            supplier_additional_fees_comment : null,
            customer_additional_fees : null,
            customer_additional_fees_comment : null,
         },
         isEdit: false,
         pd_country : null,
         selectedCardIndex: null,
      };
   },
   computed: {
         is_view() {
            const is_view = localStorage.getItem('process_view_contract');
            if(is_view) return true;
            return false;
         },

         supplierTotalPrice() {
            const supplierPrice = this.inputs.pd_suplierPrice ? parseFloat(this.inputs.pd_suplierPrice ) : 0;
            const supplierFees = this.inputs.supplier_additional_fees ? parseFloat(this.inputs.supplier_additional_fees) : 0;
            if (supplierPrice && supplierFees) {
               return (supplierPrice + supplierFees).toFixed(3);
            }
            return null;
         },

         customerTotalPrice() {
            const customerPrice = this.inputs.pd_customerPrice ? parseFloat(this.inputs.pd_customerPrice ) : 0;
            const customerFees = this.inputs.customer_additional_fees ? parseFloat(this.inputs.customer_additional_fees) : 0;
            if (customerPrice && customerFees) {
               return (customerPrice + customerFees).toFixed(3);
            }
            return null;
        },
    },
   methods: {
      async loadProductsDetails(id) {
         if (id) {
            const respuesta = await get_data_products(id);
            if (respuesta) {
               const products = respuesta;
               products.sort((a, b) => a.pd_item.value.localeCompare(b.pd_item.value));
               localStorage.setItem("selectedProducts", JSON.stringify(products));
            }
         }
      },

      async loadData() {
         this.preloader = true;
         this.isLoading = true;
         this.pd_country = JSON.parse(localStorage.getItem('DataContractMaster')).country.name;
         await Promise.all([
            this.fetchData("items"),
            this.fetchData("sub_category"),
            this.fetchData("cut_size"),
            this.fetchData("grade"),
            this.fetchData("variety"),
            this.fetchData("Feature"),
            this.fetchData("org_conv"),
            this.fetchData("crop"),
            this.fetchData("pack"),
            this.fetchData("supplier_unit"),
            this.fetchData("customer_unit"),
         ]);
         const savedInputs = localStorage.getItem('DataProductDetail')
                              ? JSON.parse(localStorage.getItem('DataProductDetail'))
                              : null;
         if (savedInputs) {
            await this.set_inputs(savedInputs);
         }
         this.isLoading = false;
         this.preloader = false;
      },

      async updateTariff() {
         const from = JSON.parse(localStorage.getItem("DataContractMaster")).country.id;
         const destination = this.inputs.pd_country_destination.id;
         const product = this.inputs.pd_product.id;
         const subCategory = this.inputs.pd_subCategory?.id;
         if (from && destination && product && subCategory) {
            const dataTariff = await get_tariff(from, destination, product, subCategory); // always return an object maybe empty
            if (Object.keys(dataTariff).length > 0) {
               let dutyRate = dataTariff?.duty ?? null;
               if ( dutyRate && dutyRate === '0%' ) {
                  dutyRate = 'Free';
               }else {
                  dutyRate = dataTariff.duty_number + "%";
               }

               let tariffRate = dataTariff.tariff ?? null;
               if (tariffRate && tariffRate === '0%') {
                  tariffRate = 'Free';
               }
               this.$set(this.inputs, "pd_hts_code", dataTariff.hts_code ?? null);
               this.$set(this.inputs, "pd_duty", dutyRate);
               this.$set(this.inputs, "pd_tariff", tariffRate);
            }
         } else {
            this.$set(this.inputs, "pd_hts_code", null);
            this.$set(this.inputs, "pd_duty", null);
            this.$set(this.inputs, "pd_tariff", null);
         }
      },


      async fetchData(customTable) {
         const data = await get_data_customTable(customTable);
         if (customTable == 'items') this.items = data;
         else if (customTable == 'sub_category') this.sub_categories = data;
         else if (customTable == 'variety') this.varietyList = data;
         else if (customTable == 'Feature') this.featureList = data;
         else if (customTable == 'cut_size') this.cutSizes = data;
         else if (customTable == 'grade') this.gradeLists = data;
         else if (customTable == 'org_conv') this.orgConv = data;
         else if (customTable == 'crop') this.cropList = data;
         else if (customTable == 'pack') this.pack = data;
      },

      async set_inputs(savedInputs){
         Object.keys(savedInputs).forEach(value => {
            this.inputs[value] = savedInputs[value];
         })
      },

      redirectToSupplierDetail() {
         if (this.selectedProducts.length == 0) {
            this.$toastr.e("No products");
            return false;
         }
         this.redirected = true;
         this.$router.push({
            name: "supplier",
            query: { tab: "supplier" },
            params: { id: this.contractId },
         });
      },

      removeProduct(index) {
         this.selectedProducts.splice(index, 1); // Elimina el producto del array
         this.updateLocalStorage(); // Actualiza el localStorage
      },

      duplicateProduct(index){
         const products = [...this.selectedProducts];
         const productCopy = {...products[index]};
         if (productCopy) {
            const nextIndex = products.length;
            if (this.items[nextIndex]) {
               productCopy.pd_item = this.items[nextIndex];
            }

            // actualizar el id
            const quantityProducts = (this.selectedProducts.length) + 1;
            const uniqueId = "" + productCopy.pd_product.id + quantityProducts;
            productCopy.pd_unique_id = uniqueId;
            productCopy.pd_contrac_product_id = null;

            // ingresarlo al array
            this.selectedProducts.push(productCopy);
            this.updateLocalStorage();
         }
      },

      updateLocalStorage() {
         const products = this.selectedProducts;
         products.sort((a, b) => a.pd_item.value.localeCompare(b.pd_item.value));
         localStorage.setItem("selectedProducts", JSON.stringify(products));
      },

      async updateFilteredData() {
         this.$watch("inputs", () => {}, { deep: true, immediate: false });
         const validations = {
            pd_item: "Item required",
            pd_product: "Product required",
            pd_quantity: "Quantity required",
            pd_pack: "Pack required",  
            pd_weight: "Weight required", 
            pd_loads: "Loads required",
            pd_net: "Net required",
         };
         if (!validateForm(this.inputs, validations, this.$toastr)) {
            return;
         }
         // validar que no este repetido
         let uniqueId = '';
         for (let index = 0; index < this.selectedProducts.length; index++) {
            const element = this.selectedProducts[index];
            if (element.pd_unique_id == this.inputs.pd_unique_id) {
               if (this.isEdit) {
                  uniqueId = this.inputs.pd_unique_id;
                  this.selectedProducts.splice(index, 1);
                  this.updateLocalStorage();
               }
            }
         }
         if (!uniqueId) {
            const quantityProducts = this.selectedProducts.length;
            uniqueId = "" + this.inputs.pd_product.id + quantityProducts;
         }
         this.inputs.pd_unique_id = uniqueId;
         const newProduct = JSON.parse(JSON.stringify(this.inputs));
         this.selectedProducts.push(newProduct);
         this.isEdit = false;
         this.updateLocalStorage();

         // resetear los inputs
         this.inputs = {
            pd_item: null,
            pd_typedata: null,
            pd_subCategory: null,
            pd_product: { id: null },
            pd_feature: null,
            pd_variety : null,
            pd_cut_size: null,
            pd_grade: null,
            pd_crop: null,
            pd_quantity: null,
            pd_pack: null,
            pd_weight: null,
            pd_net: {id: null},
            pd_supplierCurrency: { id: null},
            pd_suplierPrice: null, 
            pd_supplierUnit: { id : null},
            pd_customerCurrency: { id: null },
            pd_customerPrice: null,
            pd_customerUnit: { id: null},
            pd_country_destination: { id: null }, 
            pd_hts_code : null,
            pd_duty: null, 
            pd_tariff: null, 
            pd_loads: null,
            pd_quantity_detail: null,
            pd_note: null,
            supplier_price_detail : null,
            supplier_qty_detail : null,
            customer_price_detail : null,
            customer_qty_detail : null,
            supplier_additional_fees : null,
            supplier_total_price : null,
            supplier_additional_fees_comment : null,
            customer_additional_fees : null,
            customer_additional_fees_comment : null,
         };
         localStorage.removeItem("DataProductDetail");

      },

      handleCardClick(product, index) {
         this.selectedCardIndex = index;
         this.preloader = true;
         const copyProduct = structuredClone(product);

         setTimeout(() => {
            this.inputs = {};
            this.$nextTick(() => { // Si usas Vue
               this.inputs = copyProduct;
               this.isEdit = true;
               this.preloader = false;
            });
         }, 2500);
      },
   },

   watch: {
      inputs: {
         deep: true,
         handler(newVal) {
            if(this.isLoading) return;
            localStorage.setItem("DataProductDetail", JSON.stringify(newVal));
         },
      },
   },

   async mounted() {
      this.contractId = this.$route.params.id;
      if (!this.contractId && !localStorage.getItem("selectedProducts")) {
         this.contractId = JSON.parse(localStorage.getItem("DataContractDetail")).cd_contract_id;
      }
      if (this.contractId) {
         await this.loadProductsDetails(this.contractId);
      }
      if (typeof localStorage.getItem('is_from_cost') !== 'undefined' && localStorage.getItem('is_from_cost')) {  
         this.isFromCost = true;
      }

      this.loadData();
      const savedProducts = localStorage.getItem("selectedProducts");
      if (savedProducts) {
         this.selectedProducts = JSON.parse(savedProducts);
      }
   },
};
</script>
